import { Button, IconButton } from '@mui/material';
import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined';
import React from 'react';
import { useUserRightUtil } from '../../../../../../util/rights';
import useStateBoolean from '../../../../../../util/hooks/useStateBoolean';
import LabFiltersModal from './LabFiltersModal';
import useLabFilters from './useLabFilters';
import { ChartsIcon, ListIcon } from '../../../../../../theme/icons';
import { useMetrics } from '../../../../../../redux/monitoring/hooks/useMetrics';
import { ZipDeviceControlUnit } from '../../../../../../redux/controlUnit/controlUnit.model';
import { ConnectionInfoFiltersModalButton } from './ConnectionInfoFilters';
import { CloudGeneratedFiltersFiltersModalButton } from './CloudGeneratedFilters';

interface LabButtonComboProps {
  labStateFilters: ReturnType<typeof useMetrics>['labStateFilters'];
  devicesControlUnits: ZipDeviceControlUnit[];
}

function LabButtonCombo(props: LabButtonComboProps) {
  const { labStateFilters, devicesControlUnits } = props;
  const {
    connectionDigitalFilterControls: [
      connectionDigitalFilterControl,
      setConnectionDigitalFilterControl,
    ],
    cloudGeneratedFilterControls: [
      cloudGeneratedFilterLogicalObject,
      setCloudGeneratedFilterLogicalObject,
    ],
    viewModeControls: [viewMode, setViewMode],
  } = labStateFilters;
  const rightsUserUtil = useUserRightUtil();
  const showDeviceInfo = rightsUserUtil.isSupportUser();
  const [showLab, open, closeLab] = useStateBoolean(false);
  const toggleTableView = () => {
    setViewMode((prev) => (prev === 'table' ? 'default' : 'table'));
  };

  const { data } = useLabFilters();

  if (!showDeviceInfo) return null;

  return (
    <>
      {!!data.labBandwidthFeature && (
        <CloudGeneratedFiltersFiltersModalButton
          devicesControlUnits={devicesControlUnits}
          value={cloudGeneratedFilterLogicalObject}
          onSave={setCloudGeneratedFilterLogicalObject}
        />
      )}
      {!!data.labConnectionFeature && (
        <ConnectionInfoFiltersModalButton
          devicesControlUnits={devicesControlUnits}
          value={connectionDigitalFilterControl}
          onSave={setConnectionDigitalFilterControl}
        />
      )}
      {!!data.labTableFeature && (
        <Button variant="outlined" size="small" onClick={toggleTableView}>
          {viewMode === 'table' ? <ChartsIcon /> : <ListIcon />}
        </Button>
      )}
      <IconButton onClick={open} color="primary">
        <ScienceOutlinedIcon />
      </IconButton>
      <LabFiltersModal open={showLab} onClose={closeLab} />
    </>
  );
}

export default LabButtonCombo;
